import { render } from "./FromRender.vue?vue&type=template&id=ae3c96a4"
import script from "./FromRender.vue?vue&type=script&language=ts&lang=js"
export * from "./FromRender.vue?vue&type=script&language=ts&lang=js"
script.render = render

export default script